module.exports = __webpack_public_path__ + "static/media/team_4.4756a724.jpg";